<template>
  <el-dialog
    :class="['cargo-dialog',minSize?'minSize':'']"
    :visible.sync="innerVisible"
    :title="title"
    :width="minSize?'240px':width"
    :top="top"
    :custom-class="customClass"
    :fullscreen="fullscreen"
    :modal="false"
    :close-on-click-modal="false"
    :close-on-press-escape="false"
    :show-close="false"
  >
    <template slot="title">
      <div class="cargo-dialog__header">
        <div class="title">
          <slot name="title">
            {{ title }}
          </slot>
        </div>
        <div class="operation">
          <i v-if="(canMinimize) && !minSize" class="el-icon-minus" @click="onModalMin" />
          <i v-if="onlyCanMinimize && onlyCanMin" style="padding: 0 5px" :class="'el-icon-full-screen'" @click="onModalPlus" />
          <i v-if="!onlyCanMinimize && (canMaximize || canMinimize)" style="padding: 0 5px" :class="!fullscreen|| minSize?'el-icon-full-screen':'el-icon-copy-document'" @click="onModalPlus" />
          <i class="el-icon-close" @click="handleClose" />
        </div>
      </div>
    </template>
    <slot v-show="!minSize" />
    <template v-if="!minSize" slot="footer">
      <slot name="footer" />
    </template>
  </el-dialog>
</template>

<script>
export default {
  name: 'CargoDialog',
  props: {
    visible: {
      type: Boolean,
      default: () => false
    },
    title: {
      type: String,
      default: () => ''
    },
    width: {
      type: String,
      default: () => '50%'
    },
    top: {
      type: String,
      default: () => '15vh'
    },
    customClass: {
      type: String,
      default: () => ''
    },
    onlyCanMinimize: { type: Boolean, default: () => false }, // 仅支持最小化
    canMinimize: { type: Boolean, default: () => false },
    canMaximize: { type: Boolean, default: () => false },
    source: { type: String, default: () => '' }
  },
  data() {
    return {
      fullscreen: false,
      minSize: false,
      onlyCanMin: false // 仅支持最小化
    }
  },
  computed: {
    innerVisible: {
      get() {
        return this.visible
      },
      set(val) {
        if (!val) {
          this.$emit('close')
        }
      }
    }
  },
  methods: {
    handleClose() {
      this.innerVisible = false
    },
    onModalMin() {
      this.minSize = this.canMinimize
      if (this.onlyCanMinimize && !this.onlyCanMin) {
        this.onlyCanMin = true
      }
      this.$emit('modalMin')
    },
    onModalPlus() {
      if (this.minSize) {
        this.minSize = false
        if (this.onlyCanMinimize && this.onlyCanMin) {
          this.onlyCanMin = false
        }
        return
      }
      if (this.fullscreen) {
        this.fullscreen = false
        this.$emit('fullscreen', false)
        return
      }
      this.fullscreen = this.canMaximize
      if (this.fullscreen) {
        this.$emit('fullscreen', true)
      }
    }
  }
}
</script>

<style lang="scss">
.cargo-dialog {
  .el-dialog {
    display: flex;
    flex-direction: column;
    &__body{
      display: flex;
      flex-direction: column;
      flex-grow: 1;
    }
  }
  &.el-dialog__wrapper{
    background-color: rgba(0,0,0,.3);
    &.minSize {
      width: 250px;
      height: 60px;
      top:unset;
      left:unset;
      bottom:-20px;
      right: 0;
      .el-dialog {
        top:0 !important;
        left: 0 !important;
        margin: 0!important;
      }
    }
  }
  &__header {
    width:100%;display: flex;justify-content:space-between;
    .title,.operation {
      font-size:16px!important;
      i{
        font-size:16px;
        cursor: pointer;
      }
    }
  }
}

</style>
